import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Por favor, preencha este campo';

export const publishStepSchema = yup.object({
  publish: yup
    .string()
    .required('Selecione uma das duas opções disponiveis para continuar'),
  date: yup
    .date()
    .nullable()
    .when('publish', ([publish], schema) => {
      return publish === 'scheduled'
        ? schema.concat(yup.date().required(REQUIRED_MESSAGE))
        : schema;
    }),
  time: yup
    .date()
    .nullable()
    .when('publish', ([publish], schema) => {
      return publish === 'scheduled'
        ? schema.concat(yup.date().required(REQUIRED_MESSAGE))
        : schema;
    }),
});

export type PublishStepForm = yup.InferType<typeof publishStepSchema>;
